// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1JbIf","row":"styles_row__2qrNl"};